$(function(){
    var slider = $('#model-main').slick({
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '10%',
        lazyLoad: 'progressive',
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        responsive: [
            {
                breakpoint: 1401, //1400px～のサイズに適用
                settings: {
                    centerPadding: '7%'
                }
            },
            {
                breakpoint: 768, //767px～のサイズに適用
                settings: {
                    centerPadding: '4%'
                }
            }
        ]
    });
    $('.model-thumbnail-item').on('click', function() {
        var index = $('.model-thumbnail-item').index(this);
        slider.slick('slickGoTo', index);
    });
});

$(function() {
    $('#model-main').on('beforeChange', function(event, slick, currentSlide) {
        if(currentSlide === 0) {
            $('.model-thumbnail-item').removeClass('visibility');
            $('.model-thumbnail-item:nth-child(2)').addClass('visibility');
        } else if(currentSlide === 1) {
            $('.model-thumbnail-item').removeClass('visibility');
            $('.model-thumbnail-item:nth-child(3)').addClass('visibility');
        } else if(currentSlide === 2) {
            $('.model-thumbnail-item').removeClass('visibility');
            $('.model-thumbnail-item:nth-child(4)').addClass('visibility');
        } else if(currentSlide === 3) {
            $('.model-thumbnail-item').removeClass('visibility');
            $('.model-thumbnail-item:nth-child(5)').addClass('visibility');
        } else if(currentSlide === 4) {
            $('.model-thumbnail-item').removeClass('visibility');
            $('.model-thumbnail-item:nth-child(6)').addClass('visibility');
        } else if(currentSlide === 5) {
            $('.model-thumbnail-item').removeClass('visibility');
            $('.model-thumbnail-item:nth-child(7)').addClass('visibility');
        } else if(currentSlide === 6) {
            $('.model-thumbnail-item').removeClass('visibility');
            $('.model-thumbnail-item:nth-child(1)').addClass('visibility');
        }
    });
    $('.model-thumbnail-item').on('click', function() {
        $('.model-thumbnail-item').removeClass('visibility');
        $(this).addClass('visibility');
    });
});